/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CreditCardRecurrenceLogDetail } from './creditCardRecurrenceLogDetail';
import { PageableObject } from './pageableObject';
import { SortObject } from './sortObject';

export interface PageCreditCardRecurrenceLogDetail {
  content?: Array<CreditCardRecurrenceLogDetail>;
  empty?: boolean;
  first?: boolean;
  last?: boolean;
  number?: number;
  numberOfElements?: number;
  pageable?: PageableObject;
  size?: number;
  sort?: Array<SortObject>;
  totalElements?: number;
  totalPages?: number;
}
